<div class="popUp">
  <!-- Number -->
  <div class="title">{{ column.headerName }}</div>
  <mat-form-field appearance="outline" class="aval-editinput ignore-top">
    <input
      autocomplete="off"
      class="mainInput"
      #input
      matInput
      miqOnlyNumbers
      [allowedKeyCodes]="allowedKeyCodes"
      [restrictedKeyCodes]="restrictedKeyCodes"
      [formControl]="fc"
      min="column.min"
      max="column.max"
      step="column.step"
    />
  </mat-form-field>
  <!-- Dropdown -->
  <div class="title">{{ column.headerName }} Uom</div>
  <miq-select
    #selectInput
    class="filter--select select-dropdown"
    [currentValue]="dropdownCurrentValue"
    [values]="values"
    [placeholder]="state"
    [required]="column.required"
    [column]="selectColumn"
    (currentValueChange)="setCurrentValue($event)"
  >
  </miq-select>
</div>
